import React from "react";
import { ArrowRight, Users, Briefcase, TrendingUp, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PlatformHero: React.FC = () => {
  const navigate = useNavigate();

  const stats = [
    { icon: Users, label: "다양한 인재", value: "전문가들" },
    { icon: Briefcase, label: "실시간 채용공고", value: "최신 정보" },
    { icon: TrendingUp, label: "AI 매칭", value: "스마트 추천" },
    { icon: Star, label: "직접 연결", value: "효율적 소통" },
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* 메인 헤드라인 */}
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            HR과 인재를
            <span className="text-blue-600 block">직접 연결</span>하는
            스마트한 플랫폼
          </h1>

          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            최고의 인재와 최적의 기회를 만나게 해주는 
            현대적인 채용 플랫폼입니다
          </p>

          {/* CTA 버튼들 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={() => navigate("/jobs")}
              className="px-8 py-4 bg-blue-600 text-white rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
            >
              채용공고 둘러보기
              <ArrowRight className="w-5 h-5" />
            </button>
            <button
              onClick={() => navigate("/search")}
              className="px-8 py-4 border-2 border-blue-600 text-blue-600 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors flex items-center justify-center gap-2"
            >
              인재 검색하기
              <Users className="w-5 h-5" />
            </button>
          </div>

          {/* 통계 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg mb-3">
                  <stat.icon className="w-6 h-6 text-blue-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformHero;
